module.exports = __webpack_public_path__ + "static/img/honour1.5166b16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/honour1.png
// module id = YWUx
// module chunks = 1